import {
  acceptRequest,
  cancelRequest,
  declineRequest,
  getRelationship,
  list,
  listMutual,
  remove,
  searchFriends,
  searchProfiles,
  sendRequest,
  summary,
} from "./endpoints";

export { service } from "./endpoints";
export {
  FriendListTab,
  FriendProfileIdParams,
  FriendRelationshipResponse,
  FriendSearchQuery,
  FriendSummaryResponse,
  ListFriendsQuery,
  ListFriendsResponse,
  ListMutualFriendsQuery,
  ListMutualFriendsResponse,
  ProfileSearchResult,
  SearchFriendsResponse,
  SearchProfilesResponse,
  SendFriendRequestBody,
  SendFriendRequestResponse,
} from "./schemas";

export const contract = {
  list,
  delete: remove,
  search: searchFriends,
  summary: { get: summary },
  mutualFriends: { list: listMutual },
  requests: {
    create: sendRequest,
    delete: cancelRequest,
    accept: acceptRequest,
    decline: declineRequest,
  },
  relationships: { get: getRelationship, search: searchProfiles },
} as const;
